import React from 'react';
import { Button } from './Button';
import { Modal } from './Modal';
import { Text } from './Text';

export function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = 'Confirm',
  danger,
  loading,
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message?: string;
  confirmLabel?: string;
  danger?: boolean;
  loading?: boolean;
}) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      width={420}
      footer={
        <>
          <Button title="Cancel" onPress={onClose} />
          <Button title={confirmLabel} variant={danger ? 'danger' : 'primary'} loading={loading} onPress={onConfirm} testID="confirm-dialog-confirm" />
        </>
      }
    >
      {message ? <Text variant="muted">{message}</Text> : null}
    </Modal>
  );
}
